import React, { useEffect } from 'react';
import { Col, DatePicker, Form, Input, Radio, Row, Select } from 'antd';
import PropTypes from 'prop-types';
import { APP_TERMS } from '../../../app-terms';
import { CASE_FORM_TYPES, DATE_FORMAT } from '../../../appContants';
import { useUserList } from '../../../hooks/users/useUsersList';
import dayjs from 'dayjs';

const { Option } = Select;

const PatientDetails = ({ form }) => {
  const { data, getAllUsersList } = useUserList();

  useEffect(() => {
    getAllUsersList();
  }, []);

  return (
    <Form
      name={CASE_FORM_TYPES.patientDetails}
      form={form}
      layout="vertical"
      autoComplete="off"
    >
      <Row gutter={16} className="mt-3">
        <Col>
          <h4>{`${APP_TERMS.generic_patients} ${APP_TERMS.generic_details}`}</h4>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={12} md={8}>
          <Form.Item label={APP_TERMS.platform_id_label} name="platformId">
            <Input placeholder={APP_TERMS.platform_id_placeholder} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label={`${APP_TERMS.generic_first} ${APP_TERMS.generic_name}`}
            name="firstName"
            rules={[
              {
                required: true,
                message: 'Please input your first name!',
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label={`${APP_TERMS.generic_last} ${APP_TERMS.generic_name}`}
            name="lastName"
            rules={[
              {
                required: true,
                message: 'Please input your last name!',
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label={APP_TERMS.generic_gender}
            name="gender"
            rules={[
              {
                required: true,
                message: 'Please select your gender!',
              },
            ]}
          >
            <Radio.Group>
              <Radio value="MALE"> {APP_TERMS.generic_gender_male} </Radio>
              <Radio value="FEMALE"> {APP_TERMS.generic_gender_female} </Radio>
              <Radio value="OTHER"> {APP_TERMS.generic_gender_other} </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label={APP_TERMS.date_of_birth_label}
            name="dob"
            getValueProps={(value) => ({
              value: value && dayjs(value),
              format: DATE_FORMAT
            })}
            normalize={(value) => value && `${dayjs(value).toISOString()}`}
            rules={[
              {
                required: true,
                message: 'Please input your date of birth!',
              },
            ]}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label={`${APP_TERMS.generic_scan} ${APP_TERMS.generic_date}`}
            name="scannedAt"
            getValueProps={(value) => ({
              value: value && dayjs(value),
              format: DATE_FORMAT
            })}
            normalize={(value) => value && `${dayjs(value).toISOString()}`}
            rules={[
              {
                required: true,
                message: 'Please input scan date!',
              },
            ]}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label={`${APP_TERMS.generic_referring} ${APP_TERMS.generic_doctor}`}
            name="doctorUserSub"
            rules={[
              {
                required: true,
                message: 'Please input referring doctor!',
              },
            ]}
          >
            <Select placeholder="Select an option" allowClear>
              {(data?.items || [])?.map((doctor) => (
                <Option key={doctor?.sub} value={doctor?.sub}>
                  {doctor?.fullName}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label={`${APP_TERMS.generic_next} ${APP_TERMS.generic_appointement}`}
            name="nextAppointmentAt"
            getValueProps={(value) => ({
              value: value && dayjs(value),
              format: DATE_FORMAT
            })}
            normalize={(value) => value && `${dayjs(value).toISOString()}`}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

PatientDetails.propTypes = {
  form: PropTypes.any,
};

export default PatientDetails;
